import React from 'react';
import { Link } from 'react-router-dom';
import { Result, Button } from 'antd';

import './NotAuthorized.css';

export const NotAuthorized = () => {
  return (
    <Result
      status='403'
      title=''
      subTitle='Sorry, you are not authorized to access this page.'
      extra={
        <Button type='primary'>
          <Link to='/'>Home Page</Link>
        </Button>
      }
    />
  );
};
